import { ProducersLoaded, ProducerConfigurationLoaded, AllProducersUpdated,
  ProducerAdded, ProducerUpdated, ProducerDeleted, ProducersUploaded, ProducersImported, ProducerDefaultsUpdated
} from "./producers.action";
import { Producer, getProducerDisplayName } from "./producer";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import ProducerConfiguration from "./producerConfiguration";
import ProducerBulkUploadResponse from "./uploadProducersResponse"
import * as _ from "lodash";

export class ProducersReducer extends ReducerBase<Producer[]> {
  constructor() {
    super();
    this.addHandler(ProducersLoaded.EventName, this.handleProducersLoaded);
    this.addHandler(ProducerAdded.EventName, this.handleProducerAdded);
    this.addHandler(ProducerUpdated.EventName, this.handleProducerUpdated);
    this.addHandler(ProducerDeleted.EventName, this.handleProducerDeleted);
    this.addHandler(AllProducersUpdated.EventName, this.handleAllProducersUpdated);
  }

  handleProducersLoaded(
    state: Producer[] = initialState.producers
    , event: ProducersLoaded): Producer[] {
    return _.sortBy(event.producers, p => getProducerDisplayName(p).toLowerCase());
  }

  handleDefault(state: Producer[] = initialState.producers) {
    return state;
  }

  handleProducerAdded(
    state: Producer[] = initialState.producers,
    event: ProducerAdded
  ): Producer[] {
    return _.sortBy([...state ?? [], { ...event.newProducer }], p => getProducerDisplayName(p).toLowerCase());    
  }

  handleProducerUpdated(
    state: Producer[] = initialState.producers,
    event: ProducerUpdated
  ): Producer[] {

    return _.sortBy(state?.map(p => (p.id === event.producer.id ? event.producer : p)), p => getProducerDisplayName(p).toLowerCase());
  }

  handleProducerDeleted(
    state: Producer[] = initialState.producers,
    event: ProducerDeleted
  ): Producer[] {
    return state.filter(p => (p.id !== event.producer.id));
  }

  handleAllProducersUpdated(
    state: Producer[] = initialState.producers,
    event: AllProducersUpdated
  ): any {
    return event.producers;
  }

}

export class ProducerConfigurationReducer extends ReducerBase<ProducerConfiguration> {
  constructor() {
    super();
    this.addHandler(
      ProducerConfigurationLoaded.EventName,
      this.handleConfigurationLoaded
      );
    this.addHandler(ProducerDefaultsUpdated.EventName, this.ProducerDefaultsUpdated);
  }

  handleConfigurationLoaded(state: ProducerConfiguration = initialState.producerConfiguration, event: ProducerConfigurationLoaded
  ): ProducerConfiguration {
    return event.configuration;
  }

  ProducerDefaultsUpdated(state: ProducerConfiguration = initialState.producerConfiguration, event: ProducerDefaultsUpdated
  ): ProducerConfiguration {
    return { ...state, producerDefaults: event.producerDefaults }
  }

  handleDefault(state: ProducerConfiguration = initialState.producerConfiguration) {
    return state;
  }
}

export class ProducerBulkUploadResponseReducer extends ReducerBase<ProducerBulkUploadResponse> {
  constructor() {
    super();
    this.addHandler(ProducersUploaded.EventName, this.handleProducerUploaded);
    this.addHandler(ProducersImported.EventName, this.handleProducerImported);
  }

  handleProducerUploaded(
    state: ProducerBulkUploadResponse = initialState.producerBulkUploadResponse,
    event: ProducersUploaded
  ): ProducerBulkUploadResponse {
    return event.producerBulkUploadResponse;
  }

  handleProducerImported(
    state: ProducerBulkUploadResponse = initialState.producerBulkUploadResponse,
    event: ProducersUploaded
  ): ProducerBulkUploadResponse {
    return event.producerBulkUploadResponse;
  }

  handleDefault(state: ProducerBulkUploadResponse = initialState.producerBulkUploadResponse) {
    return state;
  }
}